// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3KfG6","content":"LayoutSettings_content__2OyYg"};